import React from 'react';
import {
  FaBoxes,
  FaSearch,
  FaExchangeAlt,
  FaChartBar,
  FaArrowRight,
  FaBoxOpen,
  FaTruck,
  FaChartLine,
  FaClipboardList,
} from 'react-icons/fa';

const EdenManager = () => {
  const features = [
    {
      icon: <FaBoxes />,
      title: 'Gestion des stocks',
      text: 'Suivez vos stocks en temps réel et évitez les ruptures.',
    },
    {
      icon: <FaSearch />,
      title: 'Suivi des produits',
      text: 'Retrouvez toutes les informations de vos produits en un clin d\'œil.',
    },
    {
      icon: <FaExchangeAlt />,
      title: 'Entrées & sorties',
      text: 'Gérez les mouvements de stock avec précision et simplicité.',
    },
    {
      icon: <FaChartBar />,
      title: 'Données de gestion',
      text: 'Consultez des indicateurs clairs pour piloter votre activité.',
    },
  ];

  const stats = [
    { value: '1 250', label: 'Produits en stock' },
    { value: '48', label: 'Commandes du jour' },
    { value: '12,5M', label: 'Valeur du stock (FC)' },
    { value: '98%', label: 'Précision inventaire' },
  ];

  const chartBars = [45, 65, 50, 80, 60, 90, 70, 95, 75, 85, 65, 88];

  return (
    <section id="eden" className="eden section">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Notre solution de gestion</span>
          <h2 className="section-title">EDEN Manager — Pilotez votre activité en toute sérénité</h2>
          <p className="section-subtitle">
            EDEN Manager est une solution complète de gestion qui vous permet de gérer vos stocks,
            suivre vos produits et piloter votre activité avec des données fiables et en temps réel.
          </p>
        </div>

        <div className="eden-dashboard">
          <div className="eden-dashboard-header">
            <div className="eden-dashboard-title">
              <div className="eden-dashboard-logo">EDEN</div>
              <span>Manager</span>
            </div>
            <div className="eden-dashboard-actions">
              <div className="eden-dashboard-action">+ Nouveau produit</div>
              <div className="eden-dashboard-action">Exporter</div>
            </div>
          </div>

          <div className="eden-dashboard-stats">
            {stats.map((stat, index) => (
              <div className="eden-dashboard-stat" key={index}>
                <span className="eden-dashboard-stat-value">{stat.value}</span>
                <span className="eden-dashboard-stat-label">{stat.label}</span>
              </div>
            ))}
          </div>

          <div className="eden-dashboard-main">
            <div className="eden-chart">
              <div className="eden-chart-header">
                <h4>Vue d'ensemble des ventes</h4>
                <span className="eden-chart-period">30 derniers jours</span>
              </div>
              <div className="eden-chart-bars">
                {chartBars.map((height, index) => (
                  <div className="eden-chart-bar-col" key={index}>
                    <div
                      className="eden-chart-bar"
                      style={{ height: `${height}%` }}
                    ></div>
                  </div>
                ))}
              </div>
            </div>

            <div className="eden-recent">
              <div className="eden-recent-header">
                <h4>Activité récente</h4>
              </div>
              <div className="eden-recent-list">
                <div className="eden-recent-item">
                  <div className="eden-recent-icon"><FaBoxOpen /></div>
                  <div className="eden-recent-info">
                    <span className="eden-recent-title">Entrée de stock</span>
                    <span className="eden-recent-desc">Riz parfumé 25kg</span>
                  </div>
                  <span className="eden-recent-amount">+50</span>
                </div>
                <div className="eden-recent-item">
                  <div className="eden-recent-icon"><FaTruck /></div>
                  <div className="eden-recent-info">
                    <span className="eden-recent-title">Sortie de stock</span>
                    <span className="eden-recent-desc">Huile végétale 5L</span>
                  </div>
                  <span className="eden-recent-amount eden-recent-amount-out">-12</span>
                </div>
                <div className="eden-recent-item">
                  <div className="eden-recent-icon"><FaChartLine /></div>
                  <div className="eden-recent-info">
                    <span className="eden-recent-title">Vente enregistrée</span>
                    <span className="eden-recent-desc">Farine de blé 50kg</span>
                  </div>
                  <span className="eden-recent-amount">+8</span>
                </div>
                <div className="eden-recent-item">
                  <div className="eden-recent-icon"><FaClipboardList /></div>
                  <div className="eden-recent-info">
                    <span className="eden-recent-title">Inventaire mis à jour</span>
                    <span className="eden-recent-desc">Sucre 1kg</span>
                  </div>
                  <span className="eden-recent-amount">+120</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="eden-image-wrapper">
          <img
            src="/images/african-warehouse.jpg"
            alt="Gestion de stock en entrepôt africain - EDEN Manager"
            className="eden-image"
            loading="lazy"
          />
          <div className="eden-image-overlay"></div>
        </div>

        <div className="eden-features">
          {features.map((feature, index) => (
            <div className="eden-feature" key={index}>
              <div className="eden-feature-icon">{feature.icon}</div>
              <h4>{feature.title}</h4>
              <p>{feature.text}</p>
            </div>
          ))}
        </div>

        <div className="eden-cta">
          <div className="eden-cta-content">
            <h3>Prêt à simplifier la gestion de votre activité ?</h3>
            <p>Découvrez comment EDEN Manager peut transformer votre quotidien.</p>
          </div>
          <a href="#contact" className="btn btn-light btn-lg">
            Découvrir EDEN Manager <FaArrowRight className="btn-icon" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default EdenManager;
